import React from 'react'
import moment from 'moment'
import { BigOrder } from 'src/core/models'
import { useAppSelector } from 'src/app/hooks'
import { selectCurrencyToken } from 'src/features'
import { getFormatedPrice } from 'src/core/helpers'
import { FormLabels, CustomStatusColumn } from 'src/components'

const OrderItemMovileViewColumn: React.FC<{ bigOrder: BigOrder }> = ({ bigOrder: { order } }) => {
  const currencyCode = useAppSelector(selectCurrencyToken) || 'EUR'
  const priceFormated = getFormatedPrice(order.total, currencyCode)

  return <>
    <FormLabels
      title={order.reference}
      subtitle={moment(order.created).format('MMMM D, h:mm')}
      thirdLabel={priceFormated}
    />
    <CustomStatusColumn
      isStatusOk={order.status === 'paid'}
      isCancelled={order.is_cancelled}
    />
  </>
}

export default OrderItemMovileViewColumn
